import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, Table, Badge, Alert } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaArrowLeft, FaSearch, FaUtensils, FaCheck, FaTimes } from "react-icons/fa";
import { useComedores } from "../../../services/hooks/useComedores";
import { useProyectos } from "../../../services/hooks/useProyectos";
import ModalComedor from "../../../components/modals/ModalComedor";

const CargarComedores = () => {
  const navigate = useNavigate();

  // Usar los hooks personalizados
  const {
    comedores,
    loading: loadingComedores,
    error: errorComedores,
    createComedor,
    updateComedor,
    deleteComedor: deleteComedorApi,
    fetchComedoresByProyecto,
    clearError: clearComedorError
  } = useComedores();

  const {
    error: errorProyectos,
    clearError: clearProyectoError
  } = useProyectos();

  const [state, setState] = useState({
    comedorSeleccionado: null,
    filtro: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('create'); // 'create' o 'edit'
  const [comedorToEdit, setComedorToEdit] = useState(null);

  // Cargar comedores del proyecto al montar el componente
  useEffect(() => {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    if (selectedProject && selectedProject.id) {
      fetchComedoresByProyecto(selectedProject.id);
    }
  }, [fetchComedoresByProyecto]);

  // Limpiar errores cuando se monta el componente
  useEffect(() => {
    if (errorComedores) clearComedorError();
    if (errorProyectos) clearProyectoError();
  }, [errorComedores, errorProyectos, clearComedorError, clearProyectoError]);

  // Función para eliminar comedor
  const handleDeleteComedor = async (comedor) => {
    if (window.confirm(`¿Está seguro de eliminar el comedor "${comedor.nombre}"?`)) {
      try {
        await deleteComedorApi(comedor.id);
        // El hook ya maneja la actualización de la lista y los toasts
      } catch (error) {
        console.error("Error al eliminar comedor:", error);
        // El error ya se maneja en el hook con toast
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  }

  // Función para manejar el guardado del comedor
  const handleSaveComedor = async (comedorData) => {
    try {
      if (modalMode === 'create') {
        await createComedor(comedorData);
      } else {
        await updateComedor(comedorToEdit.id, comedorData);
      }
      
      // Cerrar el modal
      handleCloseModal();
    } catch (error) {
      console.error('Error al guardar comedor:', error);
      // El error ya se maneja en el hook con toast
    }
  };

  // Filtrar comedores según el filtro
  const comedoresFiltrados = comedores.filter((comedor) =>
    comedor.nombre.toLowerCase().includes(state.filtro.toLowerCase())
  );

  return (
    <>
      {/* Digital Harmony Styles para Mantenimiento Comedores */}
      <style>
        {`
          /* Fondo degradado */
          .dh-maintenance-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          /* Header principal */
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          
          .dh-main-title {
            font-size: 2.2rem;
            font-weight: 700;
            margin: 0;
          }
          
          .dh-main-subtitle {
            font-size: 1.1rem;
            opacity: 0.9;
            margin: 0.5rem 0 0 0;
          }
          
          /* Cards con Digital Harmony */
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
          }
          
          .dh-card-header {
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-weight: 700;
          }
          
          /* Botones Digital Harmony */
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(251, 191, 36, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-warning:hover {
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(251, 191, 36, 0.4);
            color: white;
          }
          
          .btn-dh-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-danger:hover {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          /* Campos de formulario modernos */
          .dh-form-control {
            border: 2px solid #e5e7eb;
            border-radius: 10px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: rgba(255, 255, 255, 0.9);
          }
          
          .dh-form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
            background: white;
          }
          
          /* Enhanced Table */
          .dh-enhanced-table {
            border-collapse: separate;
            border-spacing: 0;
            border-radius: 15px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            background: white;
          }
          
          .dh-enhanced-table thead th {
            background: #374151 !important;
            color: white !important;
            font-weight: 700 !important;
            font-size: 0.875rem !important;
            text-transform: uppercase !important;
            padding: 1rem 0.75rem !important;
            border: none !important;
            position: sticky !important;
            top: 0 !important;
            z-index: 10 !important;
          }
          
          .dh-enhanced-table tbody td {
            padding: 0.75rem;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            font-size: 0.9rem;
            vertical-align: middle;
          }
          
          .dh-enhanced-table tbody tr:hover {
            background: linear-gradient(135deg, #f9fafb 0%, rgba(102, 126, 234, 0.02) 100%) !important;
          }
          
          .dh-enhanced-table tbody tr.selected {
            background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%) !important;
            border-left: 4px solid #667eea;
          }
          
          /* Checkbox personalizado */
          .dh-checkbox {
            width: 20px;
            height: 20px;
            border: 2px solid #d1d5db;
            border-radius: 6px;
            background: white;
            cursor: pointer;
            transition: all 0.2s ease;
          }
          
          .dh-checkbox:checked {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-color: #667eea;
          }
          
          /* Badges mejorados */
          .dh-badge-success {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            color: white;
            border-radius: 10px;
            padding: 6px 12px;
            font-weight: 600;
            font-size: 0.85rem;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
          }
          
          .dh-badge-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            border-radius: 10px;
            padding: 6px 12px;
            font-weight: 600;
            font-size: 0.85rem;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
          }
        `}
      </style>

      <div className="dh-maintenance-bg">
        <ToastContainer />
        
        <div className="dh-main-header">
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="dh-main-title">
                  <FaUtensils className="me-3" />
                  Mantenimiento de Comedores
                </h1>
                <p className="dh-main-subtitle">Gestión y administración de comedores del sistema</p>
              </div>
              <Button 
                className="btn-dh-secondary d-flex align-items-center"
                onClick={() => navigate("/home")}
              >
                <FaArrowLeft className="me-2" />
                Volver
              </Button>
            </div>
          </Container>
        </div>

        <Container fluid className="py-4">
          <Row>
            <Col lg={12}>
              <Card className="dh-card">
                <Card.Header className="dh-card-header">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Lista de Comedores</h5>
                    <div className="d-flex gap-2">
                      <Button
                        onClick={() => {
                          setModalMode('create');
                          setComedorToEdit(null);
                          setShowModal(true);
                        }}
                        className="btn-dh-primary d-flex align-items-center"
                      >
                        <FaPlus className="me-2" />
                        Nuevo Comedor
                      </Button>
                      <Button
                        className="btn-dh-warning d-flex align-items-center"
                        onClick={() => {
                          if (state.comedorSeleccionado) {
                            setModalMode('edit');
                            setComedorToEdit(state.comedorSeleccionado);
                            setShowModal(true);
                          } else {
                            toast.error("Por favor seleccione un comedor para editar", {
                              position: "top-right",
                              autoClose: 2000
                            });
                          }
                        }}
                      >
                        <FaEdit className="me-2" />
                        Editar
                      </Button>
                      <Button
                        className="btn-dh-danger d-flex align-items-center"
                        onClick={() => handleDeleteComedor(state.comedorSeleccionado)}
                        disabled={!state.comedorSeleccionado}
                      >
                        <FaTrash className="me-2" />
                        Eliminar
                      </Button>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body style={{ padding: '2rem' }}>
                  <div className="mb-4">
                    <div className="position-relative">
                      <Form.Control
                        type="search"
                        className="dh-form-control"
                        placeholder="Buscar comedor..."
                        value={state.filtro}
                        onChange={(e) => setState({ ...state, filtro: e.target.value })}
                        style={{ paddingLeft: '3rem' }}
                      />
                      <FaSearch 
                        className="position-absolute" 
                        style={{ 
                          left: '1rem', 
                          top: '50%', 
                          transform: 'translateY(-50%)', 
                          color: '#6b7280' 
                        }} 
                      />
                    </div>
                  </div>

                  <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                    <Table className="dh-enhanced-table">
                      <thead>
                        <tr>
                          <th style={{ width: "50px" }}></th>
                          <th>Nombre</th>
                          <th className="text-center">Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingComedores ? (
                          <tr>
                            <td colSpan="3" className="text-center py-5">
                              <div className="d-flex flex-column align-items-center">
                                <div className="spinner-border text-primary mb-3" role="status">
                                  <span className="visually-hidden">Cargando...</span>
                                </div>
                                <span className="text-muted">Cargando comedores...</span>
                              </div>
                            </td>
                          </tr>
                        ) : comedoresFiltrados.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="text-center py-5">
                              <Alert variant="info" className="mb-0">
                                <FaUtensils className="me-2" />
                                No se encontraron comedores
                              </Alert>
                            </td>
                          </tr>
                        ) : (
                          comedoresFiltrados.map((comedor, index) => (
                            <tr 
                              key={comedor.id}
                              className={state.comedorSeleccionado?.id === comedor.id ? 'selected' : ''}
                              style={{ cursor: 'pointer' }}
                              onClick={() => setState({ ...state, comedorSeleccionado: comedor })}
                            >
                              <td>
                                <Form.Check
                                  type="checkbox"
                                  className="dh-checkbox"
                                  checked={state.comedorSeleccionado?.id === comedor.id}
                                  onChange={() => {}}
                                />
                              </td>
                              <td style={{ fontWeight: '600', color: '#374151' }}>{comedor.nombre}</td>
                              <td className="text-center">
                                {comedor.activo ? (
                                  <Badge className="dh-badge-success">
                                    <FaCheck /> Activo
                                  </Badge>
                                ) : (
                                  <Badge className="dh-badge-danger">
                                    <FaTimes /> Inactivo
                                  </Badge>
                                )}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ModalComedor
        show={showModal}
        onHide={handleCloseModal}
        onSave={handleSaveComedor}
        comedor={comedorToEdit}
      />
    </>
  );
};

export default CargarComedores;